import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "../Dashboard/Invoice/Invoice.css";
import { useLocation } from "react-router-dom";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import AddVendorModal from "../ReusableForm/AddVendorModal";
import LoadingOverlay from "../../../common/LoadingBar.js";
import loader from "../../../../assets/Image/Loader2.gif";
import AddDepartmentModal from "../ReusableForm/AddDepartmentModal";
import { useToastHandler } from "../../../common/ToastHandler";
import CustomDateInput from "../../../../context/CustomDateInput";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import ChequeRenderer from '../../AppPAges/Payroll/Cheque Layout/ChequeRenderer'


function PurchaseInvoice() {
  const { Post, _Get, GetPaginatedData } = useApi();
  let { user } = useContext(AuthContext);
  const [, setIsOpen] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [reloadData, setReloadData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invoices] = useState([]);
  const [bank, setBank] = useState([]);
  const dropdownRef = useRef(null);
  const [editingInvoiceId] = useState(null);
  const [serviceData, setServiceData] = useState([]);
  const [reloadTotal, setReloadTotal] = useState(false);
  const [showBankFields, setShowBankFields] = useState(false);
  const [showModalVendor, setShowModalVendor] = useState(false);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [showCheckFields, setShowCheckFields] = useState(false);
  const [selectedChequeLayout, setSelectedChequeLayout] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [showModalDepartment, setShowModalDepartment] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const storeId = user.store;
  const { handleToast } = useToastHandler();
  const [, setInvoicesPurchase] = useState([]);
  const [, setTotalPaidPurchase] = useState(0.0);
  const [, setTotalReceivedCreditPurchase] = useState(0.0);
  const [, setTotalUnpaidForPurchases] = useState(0.0);
  const [, setTotalOutstandingPurchase] = useState(0.0);
  const [, setTotalDueForPurchases] = useState(0.0);
  const [, setTotalPurchaseCredit] = useState(0.0);
  const [, setTotalPurchase] = useState(0.0);

  const [, setActiveButton] = useState("");
  const location = useLocation();

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    type: "purchase",
    store: storeId,
    invoice_no: "",
    date: today,
    status: "",
    pay_method_status: "pay_now",
    pay_method: "cash",
    amount: "",
    pay_amount: null,
    discount: null,
    remaining_amount: "",
    after_discount: null,
    prepaid_tax: false,
    prepaid_tax_percentage: "",
    vendor_department: "",
    vendor_department_name: "",
    cheque_no: "",
    note: "",
    due_date: null,
    bank: "",
    cheque_layout:null
  });

  const chequePreviewData = {
    name: formData.vendor_department_name || "",
    amount: formData.amount || "0.00",
    date: formData.date || today,
    chequeNumber: formData.cheque_no || "",
  };

  useEffect(() => {
    setActiveButton(location.pathname);
  }, [location.pathname]);

  const handleShowVendor = () => setShowModalVendor(true);

  const handleCloseModal = () => {
    setShowModalDepartment(false);
  };

  const handleNewDepartment = (newDepartment) => {
    const newDepartmentData = {
      id: newDepartment.id,
      title: newDepartment.title,
      type: "department",
    };

    setServiceData((prevData) => [...prevData, newDepartmentData]);
    setSelectedDepartment(newDepartmentData);
    setFormData((prevData) => ({
      ...prevData,
      vendor_department_service_titles: newDepartment.title,
    }));

    setShowModalDepartment(false);
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      prepaid_tax: checked,
    }));
  };

  useEffect(() => {
    handlePaymentMethodChange({
      target: { name: "pay_method_status", value: formData.pay_method_status },
    });
    handleSpecificPaymentMethodChange({
      target: { name: "pay_method", value: formData.pay_method },
    });
  }, []);

  const handleSpecificPaymentMethodChange = (e) => {
    const value = e.target.value;
    setSelectedPaymentMethod(value);
    setShowCheckFields(value === "cheque");
    setShowBankFields(value === "bank");
    if (value !== "cheque") {
      setSelectedChequeLayout(null);
    }
    setFormData((prevData) => ({
      ...prevData,
      pay_method: value,
    }));
  };

  const handleVendorAdded = (newVendor) => {
    setVendors((prevVendors) => [...prevVendors, newVendor]);
    setFormData({ ...formData, vendor_department: newVendor.id });

    const event = {
      target: {
        name: "vendor_department",
        value: newVendor.id,
      },
    };
    handleChange(event);
  };
  const updateVendors = (newVendor) => {
    setVendors((prev) => [...prev, newVendor]);
  };



  const makeBlank = () => {
    setFormData({
      invoice_no: "",
      date: today,
      status: "",
      pay_method_status: "pay_now",
      pay_method: "cash",
      amount: "",
      pay_amount: null,
      discount: null,
      remaining_amount: "",
      after_discount: null,
      prepaid_tax: false,
      prepaid_tax_percentage: "",
      vendor_department: "",
      vendor_department_name: "",
      cheque_no: "",
      note: "",
      due_date: null,
      bank: "",
    });

    setSelectedDepartment(null);
    setShowCheckFields(false);
    setShowBankFields(false);
    setShowAdditionalFields(false);

    handlePaymentMethodChange({
      target: { name: "pay_method_status", value: "pay_now" },
    });

    handleSpecificPaymentMethodChange({
      target: { name: "pay_method", value: "cash" },
    });
  };

  const fetchData = async () => {
    try {
      const [vendorsResponse, serviceResponse, dueDaysResponse, bankResponse] =
        await Promise.all([
          GetPaginatedData("vendorDepartmentData", {
            page: 1,
            search: "",
            queryParams: {},
          }),
          GetPaginatedData("vendorDepartmentServiceData", {
            page: 1,
            search: "",
            queryParams: {},
          }),
          GetPaginatedData("dueDaysData", {
            page: 1,
            search: "",
            queryParams: {},
          }),
          GetPaginatedData("bank", {
            page: 1,
            search: "",
            queryParams: {},
          }),
        ]);

      const vendorsData = vendorsResponse?.data || [];
      const serviceDataRaw = serviceResponse?.data || [];
      const dueDaysData = dueDaysResponse?.data || [];
      const bankData = bankResponse?.data || [];

      // Map service data to handle new API structure
      const mappedServiceData = serviceDataRaw.map(item => {
        if (item.all_department_detail) {
          return {
            id: item.id,
            type: "department",
            title: item.all_department_detail.title,
            description: item.all_department_detail.description
          };
        }
        if (item.all_expense_type_detail) {
          return {
            id: item.id,
            type: "expense type",
            title: item.all_expense_type_detail.title,
            description: item.all_expense_type_detail.description
          };
        }
        return item;
      }).filter(Boolean);

      setVendors(vendorsData);
      setServiceData(mappedServiceData);
      setDueDays(dueDaysData);
      setBank(bankData);
    } catch (error) {
      console.error("Error fetching data:", error);
      handleToast({
        type: "ERROR",
        message: "Error fetching data:" + error,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDepartmentSelect = (selected) => {
    if (selected) {
      // Handle "Add Department" option
      if (selected.id === "add-department" || selected.value === "add-department") {
        setShowModalDepartment(true);
        return;
      }
      
      const title = selected.title || selected.all_department_detail?.title || "";
      setSelectedDepartment(selected);
      setFormData((prevData) => ({
        ...prevData,
        vendor_department_service_titles: title,
      }));
    } else {
      setSelectedDepartment(null);
      setFormData((prevData) => ({
        ...prevData,
        vendor_department_service_titles: "",
      }));
    }
  };

  const getPurchaseCalculation = async () => {
    setLoading(true);
    _Get("purchaseCalculation")
      .then((response) => {
        setInvoicesPurchase(response);
        setTotalPaidPurchase(response.total_paid);
        setTotalReceivedCreditPurchase(response.total_received_credit);
        setTotalUnpaidForPurchases(response.total_unpaid);
        setTotalOutstandingPurchase(response.total_outstanding_credit);
        setTotalDueForPurchases(response.total_due);
        setTotalPurchaseCredit(response.total_credit);
        setTotalPurchase(response.total_purchase || 0);
      })
      .catch((error) => {
        handleToast({
          type: "ERROR",
          message: "Error fetching invoices:" + error,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getPurchaseCalculation();
  }, [reloadTotal]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      remaining_amount: prevData.amount,
    }));
  }, [formData.amount]);

  const [vendors, setVendors] = useState([]);
  const [dueDays, setDueDays] = useState([]);

  const handleCloseVendor = () => {
    setShowModalVendor(false);
  };

  const [showPaymentOptions, setShowPaymentOptions] = useState(
    formData.pay_method_status === "pay_now"
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    let updatedRemainingAmount = 0;
    if (
      formData.pay_method === "pay_later" &&
      formData.pay_method_status === "pay_later"
    ) {
      updatedRemainingAmount =
        parseFloat(formData.amount) - parseFloat(formData.pay_amount || 0);
    } else {
      updatedRemainingAmount = 0;
    }
    formData.remaining_amount =
      updatedRemainingAmount >= 0 ? updatedRemainingAmount.toFixed(2) : "0.00";

    if (!formData.vendor_department) {
      handleToast({
        type: "ERROR",
        message: "Please Select a Vendor.",
      });
      return;
    }
    if (!formData.invoice_no) {
      handleToast({
        type: "ERROR",
        message: "Invoice number is required.",
      });
      return;
    }
    if (!formData.vendor_department_service_titles) {
      handleToast({
        type: "ERROR",
        message: "Please select a department",
      });
      return;
    }

    if (formData.pay_method_status === "pay_later") {
      if (!formData.pay_method) {
        handleToast({
          type: "ERROR",
          message: "Please select a payment method.",
        });
        return;
      }

      if (!formData.due_date) {
        handleToast({
          type: "ERROR",
          message: "Please select a Due Date.",
        });
        return;
      }
      if (!formData.amount) {
        handleToast({
          type: "ERROR",
          message: "Please fill in the Amount.",
        });
        return;
      }
    }

    if (formData.pay_method_status === "pay_now") {
      if (!formData.pay_method) {
        handleToast({
          type: "ERROR",
          message: "Please select a payment method.",
        });
        return;
      }

      if (formData.pay_method === "cash") {
        if (!formData.amount) {
          handleToast({
            type: "ERROR",
            message: "Please fill in the Amount.",
          });
          return;
        }
      }

      if (formData.pay_method === "bank") {
        if (!formData.bank) {
          handleToast({
            type: "ERROR",
            message: "Please select a Bank.",
          });
          return;
        }
        if (!formData.amount) {
          handleToast({
            type: "ERROR",
            message: "Please fill in the Amount",
          });
          return;
        }
      }

      if (formData.pay_method === "cheque") {
        if (!formData.bank) {
          handleToast({
            type: "ERROR",
            message: "Please select a Bank",
          });
          return;
        }

        if (!formData.cheque_no) {
          handleToast({
            type: "ERROR",
            message: "Please fill in the Cheque No",
          });
          return;
        }
        if (!formData.amount) {
          handleToast({
            type: "ERROR",
            message: "Please fill in the Amount",
          });
          return;
        }
      }
    }

    const updatedFormData = {
      ...formData,
      amount: formData.amount,
      ...(formData.pay_method_status === "pay_now" && {
        pay_amount: formData.pay_amount || formData.amount,
      }),
    };
    if (formData.pay_method_status === "pay_now") {
      setShowPaymentOptions(true);
      updatedFormData.status = "paid";
      updatedFormData.due_date = null;
    }
    try {
      const duplicateInvoice = invoices.some(
        (invoice) => invoice.invoice_no === formData.invoice_no
      );
      if (duplicateInvoice) {
        handleToast({
          type: "ERROR",
          message: "Invoice number must be unique.",
        });
        return;
      }
      const newInvoiceData = {
        ...updatedFormData,

          cheque_layout:
          formData.pay_method === "cheque"
            ? selectedChequeLayout?.id || null
            : null,

        remaining_amount:
          formData.pay_method_status === "pay_now" ? "0.00" : formData.amount,
        status: formData.pay_method_status === "pay_now" ? "paid" : "unpaid",
      };

      const response = await Post("createInvoiceAndPrepaidTax", newInvoiceData);
      if (response.status === 200 || response.status === 201) {
        
        // Call cheque API if payment method is cheque
        if (formData.pay_method === "cheque") {
          const chequePayload = {
            store: storeId,
            cheque_no: formData.cheque_no,
            name: formData.vendor_department_name,
            amount: formData.amount,
            created_by: user.user_id,
          };
          await Post("chequeData", chequePayload);
        }
        
        handleToast({
          type: "SUCCESS",
          message: "Invoice submitted successfully!",
        });
        setTimeout(() => {
          setReloadData(!reloadData);
          setReloadTotal(!reloadTotal);
          makeBlank();
        }, 500);
      } else {
        handleToast({
          type: "ERROR",
          message: "Failed to submit invoice. Status: " + response.status,
        });
      }
    } catch (error) {
      console.error("Error submitting invoice:", error);

      handleToast({
        type: "ERROR",
        message:
          "Error submitting invoice: " +
          (error.response ? error.response.data : error.message),
      });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const updatedData = {
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    };

    if (value === "add-department") {
      setShowModalDepartment(true);
      return;
    }

    if (name === "vendor_department") {
      const selectedVendor = vendors.find((vendor) => vendor.id === value);
      updatedData.vendor_department_name = selectedVendor?.name || "";
      updatedData.vendor_department_service_titles = "";
      setSelectedDepartment(null);

      if (selectedVendor) {
        const serviceTitleField =
          selectedVendor.vendor_department_service_title ||
          selectedVendor.service_titles ||
          selectedVendor.services ||
          selectedVendor.departments;

        const serviceIds =
          selectedVendor.vendor_department_service ||
          selectedVendor.service_ids ||
          selectedVendor.services_ids;
          
        if (serviceTitleField || serviceIds) {
          const vendorServiceTitles =
            typeof serviceTitleField === "string"
              ? serviceTitleField.split(",").map((title) => title.trim())
              : Array.isArray(serviceTitleField)
                ? serviceTitleField
                : serviceTitleField
                  ? [serviceTitleField]
                  : [];

          const vendorDepartments = serviceData.filter((service) => {
            const isDepartment = service.type === "department";

            const matchesVendorServiceByTitle = vendorServiceTitles.some(
              (vendorTitle) => {
                if (!vendorTitle || !service.title) return false;
                const vendorTitleLower = vendorTitle.toLowerCase();
                const serviceTitleLower = service.title.toLowerCase();
                const matches =
                  vendorTitleLower === serviceTitleLower ||
                  vendorTitleLower.includes(serviceTitleLower) ||
                  serviceTitleLower.includes(vendorTitleLower);
                return matches;
              }
            );

            const matchesVendorServiceById =
              serviceIds &&
              Array.isArray(serviceIds) &&
              serviceIds.some((serviceId) => {
                const matches = serviceId === service.id;
                return matches;
              });

            const matchesVendorService =
              matchesVendorServiceByTitle || matchesVendorServiceById;
            return isDepartment && matchesVendorService;
          });

          if (vendorDepartments.length > 0) {
            setSelectedDepartment(vendorDepartments[0]);
            updatedData.vendor_department_service_titles = vendorDepartments[0].title;
          }
        }
      }
    }

    if (name === "vendor_department_service_titles") {
      updatedData.vendor_department_service_titles = value;
    }

    if (name === "days") {
      const selectedDueDays = parseInt(value, 10);
      if (!isNaN(selectedDueDays)) {
        const today = new Date();
        const dueDate = new Date(today);
        dueDate.setDate(dueDate.getDate() + selectedDueDays);
        updatedData.due_date = dueDate.toISOString().split("T")[0];
      }
    }
    setFormData(updatedData);
  };

  const handlePaymentMethodChange = (e) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      pay_method_status: value,
      pay_method:
        value === "pay_now"
          ? "cash"
          : value === "pay_later"
            ? "pay_later"
            : "credit_invoice",
      status: value === "pay_now" ? "paid" : "unpaid",
    }));

    setShowPaymentOptions(value === "pay_now");
    setShowAdditionalFields(
      value === "credit_invoice" || value === "pay_later"
    );
    setShowCheckFields(false);
    setShowBankFields(false);
  };

  const handleCancel = () => {
    makeBlank();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLinkClick = (path) => {
    setIsOpen(false);

    navigate(path);
  };

  if (loading) {
    return (
      <LoadingOverlay loading={loading} loader={loader} />
    );
  }
  return (
    <div className="responsive-box">
      <ToastContainer />
      { }

      <div className="">
        <div className="">
          <form>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "20px",
                marginBottom: "20px",
              }}
            >
              <h3 className="mb-1" style={{ margin: "0" }}>
                Purchase Invoice
              </h3>
            </div>
            <div
              className="form-row form-group col-md-12 d-flex position-relative"
              style={{ gap: "50px", padding: "10px", marginLeft: "15px" }}
            >
              <div className="col-md-3" style={{ paddingRight: "10px" }}>
                { }

                <CustomDateInput
                  value={formData.date || today}
                  onChange={handleChange}
                  id="billDate"
                  name="date"
                  required
                  disabled={editingInvoiceId ? true : false}
                  inputStyle={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    borderRadius: "0px",
                    height: "52px",
                  }}
                />
              </div>
              <div className="col-md-3" style={{ paddingRight: "10px" }}>
                <input
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    borderRadius: "0px",
                    height: "52px",
                    outline: "none",
                    width: "100%",
                  }}
                  type="text"
                  className="form-control-borderless"
                  name="invoice_no"
                  disabled={editingInvoiceId ? true : false}
                  placeholder="Invoice Number"
                  value={formData.invoice_no}
                  onChange={handleChange}
                />
              </div>
              <div
                className="col-md-3"
                style={{ paddingRight: "10px", width: "40%" }}
              >
                <select
                  style={{
                    backgroundColor: "#ffffff",
                    height: "52px",
                  }}
                  className="input-select"
                  disabled={editingInvoiceId ? true : false}
                  name="vendor_department"
                  value={formData.vendor_department}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    if (selectedValue === "add-vendor") {
                      handleShowVendor();
                      setFormData((prevData) => ({
                        ...prevData,
                        vendor_department: "",
                      }));
                    } else {
                      handleChange(e);
                    }
                  }}
                >
                  <option value="">Select Vendor</option>
                  <option value="add-vendor">Add Vendor</option>
                  {vendors
                    .filter(
                      (vendor) =>
                        vendor.type === "purchase" && !vendor.is_deleted
                    )
                    .map((vendor) => (
                      <option key={vendor.id} value={vendor.id}>
                        {vendor.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            { }

            <div
              className="d-flex col-md-12"
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "24px",
              }}
            >
              <div className="col-md-3" style={{ paddingRight: "10px" }}>
                <PaginatedSearchSelect
                  api="vendorDepartmentServiceData"
                  GetPaginatedData={GetPaginatedData}
                  placeholder="Select Department"
                  value={selectedDepartment}
                  getOptionLabel={(opt) => opt.title || opt.all_department_detail?.title || ""}
                  onSelect={handleDepartmentSelect}
                  filterFn={(item) => {
                    const isDepartment = item.all_department_detail || item.type === "department";
                    return isDepartment;
                  }}
                  extraOptions={[
                    { id: "add-department", label: "+ Add Department", value: "add-department" }
                  ]}
                  style={{
                    backgroundColor: "#ffffff",
                    height: "52px",
                    width: "100%",
                  }}
                />
              </div>

              <div className="form-row d-flex">
                <div className="input-group col-md-6">
                  <div
                    className="input-group-prepend"
                    style={{
                      background: "#ffffff",
                      height: "22px",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "30px",
                    }}
                  >
                  </div>
                  <input
                    required
                    className="form-control-borderless"
                    placeholder="Amount"
                    aria-label="Amount"
                    aria-describedby="addon-wrapping"
                    name={editingInvoiceId ? "amount" : "amount"}
                    value={
                      editingInvoiceId && formData.pay_amount === undefined
                        ? formData.remaining_amount
                        : formData.pay_amount || formData.amount
                    }
                    onChange={handleChange}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                        .slice(0, 12);
                    }}
                    style={{ width: "300px" }}
                  />
                </div>
              </div>

              <div
                style={{
                  border: "1px solid #ACB4AA",

                  padding: "8px 8px",
                  width: "fit-content",

                  borderRadius: "40px",
                  marginTop: "10px",
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                {[
                  { value: "pay_now", label: "Pay Now" },
                  { value: "pay_later", label: "Pay Later" },
                  { value: "credit_invoice", label: "Credit Invoice" },
                ].map((option) => (
                  <label
                    key={option.value}
                    className="radio-inline"
                    style={{
                      backgroundColor:
                        formData.pay_method_status === option.value
                          ? "#4a5546"
                          : "transparent",
                      color:
                        formData.pay_method_status === option.value
                          ? "white"
                          : "black",
                      padding: "5px 20px",
                      borderRadius: "20px",
                      cursor: editingInvoiceId ? "not-allowed" : "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="pay_method_status"
                      value={option.value}
                      checked={formData.pay_method_status === option.value}
                      onChange={handlePaymentMethodChange}
                      disabled={!!editingInvoiceId}
                      style={{
                        opacity: 0,
                        position: "absolute",
                        pointerEvents: "auto",
                      }}
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </div>

            {showPaymentOptions && (
              <div
                className="d-flex col-md-6 mb-3"
                style={{
                  border: "1px solid #ACB4AA",
                  padding: "5px 6px",
                  width: "fit-content",
                  borderRadius: "40px",
                  display: "flex",
                  gap: "10px",
                  marginLeft: "20px",
                  marginTop: "40px",
                }}
              >
                <div
                  className="payment-option"
                  onClick={() =>
                    handleSpecificPaymentMethodChange({
                      target: { value: "cash" },
                    })
                  }
                  style={{
                    padding: "5px 20px",
                    cursor: "pointer",
                    borderRadius: "20px",
                    backgroundColor:
                      selectedPaymentMethod === "cash"
                        ? "#4a5546"
                        : "transparent",
                    color: selectedPaymentMethod === "cash" ? "white" : "black",
                    textAlign: "center",
                  }}
                >
                  Cash
                </div>
                <div
                  className="payment-option"
                  onClick={() =>
                    handleSpecificPaymentMethodChange({
                      target: { value: "cheque" },
                    })
                  }
                  style={{
                    padding: "5px 20px",
                    cursor: "pointer",
                    borderRadius: "20px",
                    backgroundColor:
                      selectedPaymentMethod === "cheque"
                        ? "#4a5546"
                        : "transparent",
                    color:
                      selectedPaymentMethod === "cheque" ? "white" : "black",
                    textAlign: "center",
                  }}
                >
                  Check
                </div>
                <div
                  className="payment-option"
                  onClick={() =>
                    handleSpecificPaymentMethodChange({
                      target: { value: "bank" },
                    })
                  }
                  style={{
                    padding: "5px 20px",
                    cursor: "pointer",
                    borderRadius: "20px",
                    backgroundColor:
                      selectedPaymentMethod === "bank"
                        ? "#4a5546"
                        : "transparent",
                    color: selectedPaymentMethod === "bank" ? "white" : "black",
                    textAlign: "center",
                  }}
                >
                  Bank Card/ACH/EFT
                </div>
              </div>
            )}

            {showAdditionalFields && (
              <div
                className="d-flex col-md-5 mt-2"
                style={{ marginTop: "20px", marginLeft: "37px" }}
              >
                <select
                  className="form-control-borderless col-md-4 me-2"
                  name="days"
                  value={formData.days || ""}
                  onChange={handleChange}
                  style={{
                    backgroundColor: "#fff",

                    borderBottom: "1px solid #ccc",
                    borderRadius: "0px",
                    height: "52px",
                  }}
                  required
                >
                  <option value="">Select Due Days</option>
                  {dueDays.map((day) => (
                    <option key={day.id} value={day.value}>
                      {day.days}
                    </option>
                  ))}
                </select>
                { }
              </div>
            )}
            {showCheckFields && (

              <>
                <div
                  className="d-flex col-md-6 mt-2"
                  style={{ marginLeft: "10px" }}
                >
                  <div className="d-flex col-md-4 mt-2">
                    <select
                      style={{
                        backgroundColor: "#fff",
                        border: "none",
                        borderBottom: "1px solid #ccc",
                        borderRadius: "0px",
                        height: "52px",
                        marginLeft: "13px",
                      }}
                      className="input-select"
                      name="bank"
                      value={formData.bank}
                      onChange={handleChange}
                    >
                      <option value="">Select Bank</option>
                      {bank.map((bank) => (
                        <option key={bank.id} value={bank.id}>
                          {bank.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="d-flex col-md-4 mt-2">
                    <input
                      type="text"
                      className="form-control-borderless me-2"
                      placeholder="Check Number"
                      style={{
                        backgroundColor: "#fff",
                        border: "none",
                        borderBottom: "1px solid #ccc",
                        borderRadius: "0px",
                        height: "52px",
                        marginRight: "10px",
                      }}
                      id="checkNumber"
                      name="cheque_no"
                      value={formData.cheque_no}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d{0,15}$/.test(val)) {
                          handleChange(e);
                        }
                      }}
                      maxLength={15}
                      required
                    />
                  </div>
                  <div className="d-flex col-md-4 mt-2">
                    <div style={{ width: "100%", marginTop: '20px' }}>
                      {/* <label className="form-label">Cheque Layout *</label> */}
                      <PaginatedSearchSelect
                        api="preferenceCompanyData"
                        GetPaginatedData={GetPaginatedData}
                        placeholder="Select Cheque Layout"
                        value={selectedChequeLayout}
                        getOptionLabel={(opt) => opt.layout_name}
                        onSelect={(opt) => setSelectedChequeLayout(opt)}
                      />
                    </div>
                  </div>
                </div>

                {/* Cheque Preview */}
                {selectedChequeLayout && (
                  <div className="row mt-4 mx-3">
                    <div className="col-12">
                      <h6 style={{ marginBottom: "10px" }}>Cheque Preview</h6>
                      <div
                        style={{
                          background: "#f8f9fa",
                          padding: "10px",
                          borderRadius: "8px",
                          overflowX: "auto",
                        }}
                      >
                        <ChequeRenderer
                          layout={selectedChequeLayout}
                          chequeData={chequePreviewData}
                          showPrint
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}


            {showBankFields && (
              <div className="d-flex col-md-12" style={{ marginLeft: "25px" }}>
                <div className="d-flex col-md-3 ">
                  <select
                    style={{
                      backgroundColor: "#fff",
                      border: "none",
                      borderBottom: "1px solid #ccc",
                      borderRadius: "0px",
                      height: "52px",
                      marginRight: "10px",
                    }}
                    className="input-select"
                    name="bank"
                    value={formData.bank}
                    onChange={handleChange}
                  >
                    <option value="">Select Bank</option>
                    {bank.map((bank) => (
                      <option key={bank.id} value={bank.id}>
                        {bank.name}
                      </option>
                    ))}
                  </select>
                </div>
                { }
              </div>
            )}
            <div
              className="form-row d-flex col-md-12 mt-4"
              style={{ marginLeft: "20px" }}
            >
              <label>
                Do you want to add prepaid tax? &nbsp;
                <input
                  type="checkbox"
                  id="prepaidTax"
                  onChange={handleCheckboxChange}
                  checked={formData.prepaid_tax}
                  name="prepaid_tax"
                />
              </label>
            </div>
            {formData.prepaid_tax && (
              <div
                className="form-row d-flex col-md-4 p-2 mt-2"
                style={{
                  backgroundColor: "#fff",

                  borderRadius: "0px",
                  height: "52px",
                  marginLeft: "20px",
                }}
              >
                <div className="input-group col-md-6">
                  <div
                    className="input-group-prepend"
                    style={{
                      background: "#ffffff",
                      height: "100%",

                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    { }
                  </div>
                  <input
                    type="text"
                    className="form-control-borderless"
                    placeholder="Amount"
                    aria-label="Prepaid Tax"
                    name="prepaid_amount"
                    value={formData.prepaid_amount || ""}
                    onChange={handleChange}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                        .slice(0, 12);
                    }}
                  />
                </div>
              </div>
            )}
          </form>

          <div className="modal-footer" style={{ border: "none", gap: "2%" }}>
            <button
              type="button"
              className="btn btn-secondary-outline"
              onClick={handleCancel}
              style={{
                border: " 1px solid #282e26",
                borderRadius: "50px",
                width: "181px",
                height: "45px",
                fontWeight: "bold",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                color: "white",
                backgroundColor: "#282e26",
                borderRadius: "50px",
                width: "181px",
                height: "45px",
                fontWeight: "bold",
              }}
              className="btn"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </div>

      { }

      <div>
        { }
        <AddVendorModal
          show={showModalVendor}
          handleClose={handleCloseVendor}
          onVendorAdded={handleVendorAdded}
          updateVendors={updateVendors}
        />
        <AddDepartmentModal
          show={showModalDepartment}
          handleClose={handleCloseModal}
          onDepartmentAdded={handleNewDepartment}
        />
      </div>
    </div>
  );
}

export default PurchaseInvoice;
